import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Language, LanguageCreate, LanguageFilter } from '../data/language';

export function createLanguageService(client: AxiosInstance) {
  return createCrudService<Language, LanguageCreate, LanguageFilter>(
    client,
    '/master-data/Language',
    'id',
  );
}

export type LanguageService = CrudService<Language, LanguageCreate, LanguageFilter>;
